const THERMOSTATS_LIST = (state, thermostatsList) => {
  state.thermostatsList = thermostatsList;
};

export default {
  THERMOSTATS_LIST,
};
